// extracted by mini-css-extract-plugin
module.exports = {"canvas":"CaptureBackground_canvas__Aj_1O"};